import { useState, useRef, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import UploadFileControl from '../formcomponents/uploadFileControl'
import IformBreadcrumb from '../formcomponents/iformBreadcrumb'
import { TextField, Button, Typography, InlineAlert, RadioButtons, Link } from '@nwh-consumer-digital/nw-component-lib'
import { Grid, Box, Paper } from '@mui/material'
import styled from '@emotion/styled'
import { useProgress } from '../context/ProgressContext'

const TodayTS = Date.now()

const Item = styled(Paper)(() => ({
  textAlign: 'left',
  maxWidth: '400px',
  marginBottom: '18px', // There is an extra 6 pixels this makes 24px
}))

const isValidEmail = (email) =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  )

const adultPageTwo = (props) => {
  const { updateProgress } = useProgress() //UseProgress Context Hook to set Values

  useEffect(() => {
    updateProgress(50)

    // No legal documentation required for adult family members. Specify family exceptions here
    if (!['Parent', 'Spouse', 'Daughter', 'Son', 'Other'].includes(relationshiptoPatient)) {
      setNeedsLegalDocumentation(true)
    } else {
      setNeedsLegalDocumentation(false)
      setIsFileUploadSt(true)
    }

    if (SubmissionState.sectionTwoForm) {
      setValue('firstNameGuardian', SubmissionState.sectionTwoForm?.firstNameGuardian)
      setValue('lastNameGuardian', SubmissionState.sectionTwoForm?.lastNameGuardian)
      setValue('mInitialGuardian', SubmissionState.sectionTwoForm?.mInitialGuardian)
      setValue('DOBGuardian', SubmissionState.sectionTwoForm?.DOBGuardian)
      setValue('streetNumberGuardian', SubmissionState.sectionTwoForm?.streetNumberGuardian)
      setValue('CityGuardian', SubmissionState.sectionTwoForm?.CityGuardian)
      setValue('StateGuardian', SubmissionState.sectionTwoForm?.StateGuardian)
      setValue('ZipGuardian', SubmissionState.sectionTwoForm?.ZipGuardian)
      setValue('phoneNumberGuardian', SubmissionState.sectionTwoForm?.phoneNumberGuardian)
      setValue('emailguardian', SubmissionState.sectionTwoForm?.emailguardian)
      setValue('proxyAccessLevel', SubmissionState.sectionTwoForm?.proxyAccessLevel)
    }
  }, [])

  const { SubmissionState, onFormStateChange } = props
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({ mode: 'onBlur' })
  const [isfileUploadSt, setIsFileUploadSt] = useState(false)
  const [NeedsLegalDocumentation, setNeedsLegalDocumentation] = useState(false)
  const relationshiptoPatient = SubmissionState?.sectionOneForm.relationshiptoPatient
  const patientName =
    SubmissionState.sectionOneForm.lastName + '_' + SubmissionState.sectionOneForm.firstName + '_' + TodayTS

  // Count the number of errors on the page and, if any are found, scroll to the reference above the inline alert box after tallying them.
  const errorCount = Object.keys(errors).length
  const targetRef = useRef(null)
  const scrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }
  useEffect(() => {
    if (errorCount > 0) {
      scrollToTarget()
    }
  }, [errors])

  const uploadCompleted = function (state) {
    setIsFileUploadSt(state)
  }

  const handleEmailValidation = (email) => {
    const isValid = isValidEmail(email)
    const validityChanged = (errors.email && isValid) || (!errors.email && !isValid)
    if (validityChanged) {
    }
    return isValid
  }

  const handleRegistration = (data) => {
    SubmissionState.goBackPageTwo = false
    SubmissionState.goPageThree = true
    SubmissionState.SectionTwoFormTimestamp = TodayTS
    SubmissionState.sectionTwoForm = data
    onFormStateChange()
  }

  const previousPageClick = () => {
    SubmissionState.goBackPageTwo = false
    SubmissionState.goBackPageOne = true
    SubmissionState.sectionTwoForm = getValues()
    onFormStateChange()
  }

  return (
    <Box>
      <Grid container direction="column" justifyContent="space-between" alignItems="left">
        <Grid
          item
          xs={12}
          sx={{
            marginTop: { xs: '1.25rem', sm: '1.25rem', md: '1.25rem', lg: '2rem', xl: '2rem' },
            marginBottom: { xs: '2rem', sm: '2rem', md: '2rem', lg: '2rem', xl: '2rem' },
          }}>
          <IformBreadcrumb onClick={previousPageClick}>&lt; Adult patient's information</IformBreadcrumb>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            maxWidth: window.innerWidth <= 768 ? '400px' : 'none',
            marginBottom: 24,
            textAlign: 'justify',
            lineHeight: 1.6,
            wordSpacing: '0.05em',
          }}>
          <Typography variant="h1" style={{ marginBottom: 24 }}>
            Requestor's information
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 24 }}>
          <Typography type="body" size="large" weight="light">
            {' '}
            MyNorthwell (Northwell MyChart) allows an adult patient or an adult patient's Legal Representative to
            designate full or view only access to the patient's health information to another individual (a “Proxy”).
            Proxy access does not affect the right to request access to the above names patient's medical records
            through other means. Please note, billing information is not automatically available to proxies. Only the
            patient and the individual(s) who is financially responsible for paying the patient's medical bills
            (guarantor) may see billing information. To receive medical records, patients and Proxies can use the
            Sharing Hub feature in the MyNorthwell application or visit{' '}
            <Link
              hrefLink="https://www.northwell.edu/manage-your-care/medical-records"
              linkText="https://www.northwell.edu/manage-your-care/medical-records"
            />
            &nbsp;and complete the electronic record request form. Written requests for copies of medical records may
            also be submitted to Northwell's Health Information Management Department. Please contact the provider's
            front office staff with any questions or concerns.
            <br />
            <br />
            A Proxy can either be given full or view only access to a patient's MyNorthwell account.
            <br />
            <ul>
              <li>
                With full access, Proxies can see and interact with health records, communicate with providers, schedule
                appointments, manage appointments and prescriptions, and more.
              </li>
              <li>
                With view only access, Proxies can view but not interact with, health records including sensitive
                information, messages, appointments, prescriptions, etc.
              </li>
            </ul>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            maxWidth: window.innerWidth <= 768 ? '400px' : 'none',
            marginBottom: 24,
            textAlign: 'justify',
            lineHeight: 1.6,
            wordSpacing: '0.05em',
          }}>
          <Typography type="body" size="large" weight="light">
            {' '}
            Enter the details of the requestor's information to proceed with the proxy access request for the Adult
            patient.
          </Typography>
        </Grid>
        <form id="completeFMHAdultForm" onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12} className="requiredSpacing">
            <Item elevation={0}>
              <label ref={targetRef} className="required">
                <span className="red">*</span> Required
              </label>
            </Item>
          </Grid>
          {errorCount > 0 && (
            <Grid item xs={12}>
              <Item elevation={0}>
                <InlineAlert severity="error" fullWidth text={`There are ${errorCount} errors on this page.`} />
              </Item>
            </Grid>
          )}
          <Grid item xs={12} style={{ marginBottom: 24 }}>
            <Controller
              name="proxyAccessLevel"
              control={control}
              rules={{ required: 'Proxy Access level required' }}
              render={({ field }) => (
                <RadioButtons
                  row={false}
                  {...field}
                  defaultValue={SubmissionState.sectionTwoForm?.proxyAccessLevel}
                  options={[
                    { value: 'Full Access', label: 'Full Access' },
                    { value: 'View Only Access', label: 'View Only Access' },
                  ]}
                  formLabel={
                    <span>
                      Please select the type of MyNorthwell access you want for your proxy{' '}
                      <span className="red">*</span>
                    </span>
                  }
                  error={Boolean(errors.proxyAccessLevel)}
                  helperText={errors.proxyAccessLevel?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="firstNameGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="firstNameGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.firstNameGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        First Name <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={errors?.firstNameGuardian}
                    helperText={
                      errors?.firstNameGuardian
                        ? errors?.firstNameGuardian?.type === 'required'
                          ? 'First name is required.'
                          : errors?.firstNameGuardian?.type === 'pattern'
                          ? 'First name contains invalid characters.'
                          : 'First name is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="lastNameGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="lastNameGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.lastNameGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        Last Name <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.lastNameGuardian)}
                    helperText={
                      errors?.lastNameGuardian
                        ? errors?.lastNameGuardian?.type === 'required'
                          ? 'Last name is required.'
                          : errors?.lastNameGuardian?.type === 'pattern'
                          ? 'Last name contains invalid characters.'
                          : 'Last name is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="mInitial"
                control={control}
                rules={{ pattern: { value: /^[A-Za-z]+$/, message: 'Please use alphabetic characters only' } }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    id="mInitialGuardian"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionTwoForm?.mInitialGuardian}
                    label="Middle initial"
                    fullWidth
                    error={Boolean(errors?.mInitialGuardian)}
                    helperText={errors?.mInitialGuardian?.message || ''}
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="DOBGuardian"
                control={control}
                rules={{
                  pattern:
                    /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/(19\d{2}|20[0-2]\d|20[2-9][0-9]|20[3-9][0-9]|21\d{2})$/,
                  required: true,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="DOBGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.DOBGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        Date of birth (MM/DD/YYYY) <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.DOBGuardian)}
                    helperText={
                      errors?.DOBGuardian
                        ? errors?.DOBGuardian?.type === 'required'
                          ? 'Date of Birth is required.'
                          : errors?.DOBGuardian?.type === 'pattern'
                          ? 'Please use numeric characters only, and correct Month/Date/Year values.'
                          : 'Date of Birth is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="streetNumberGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Za-z0-9 -]+$/,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="streetNumberGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.streetNumberGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        Address <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.streetNumberGuardian)}
                    helperText={
                      errors?.streetNumberGuardian
                        ? errors?.streetNumberGuardian?.type === 'required'
                          ? 'Address is required.'
                          : errors?.streetNumberGuardian?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : 'Address is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="CityGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="CityGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.CityGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        City <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.CityGuardian)}
                    helperText={
                      errors?.CityGuardian
                        ? errors?.CityGuardian?.type === 'required'
                          ? 'City is required.'
                          : errors?.CityGuardian?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : 'City is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="StateGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="StateGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.StateGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        State <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.StateGuardian)}
                    helperText={
                      errors?.StateGuardian
                        ? errors?.StateGuardian?.type === 'required'
                          ? 'State is required.'
                          : errors?.StateGuardian?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : 'State is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="ZipGuardian"
                control={control}
                rules={{
                  pattern: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
                  required: true,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="ZipGuardian"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionTwoForm?.ZipGuardian}
                    label={
                      <span>
                        Zip <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={errors?.ZipGuardian}
                    helperText={
                      errors?.ZipGuardian
                        ? errors?.ZipGuardian?.type === 'required'
                          ? 'Zipcode is required.'
                          : errors?.ZipGuardian?.type === 'pattern'
                          ? 'Please use 5 digits of numeric characters only'
                          : 'Zipcode is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="phoneNumberGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^(\+1)?[ -]?\(?([0-9]{3})\)?[ -]?([0-9]{3})[ -]?([0-9]{4})$/,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="phoneNumberGuardian"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionTwoForm?.phoneNumberGuardian}
                    label={
                      <span>
                        Phone <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.phoneNumberGuardian)}
                    helperText={
                      errors?.phoneNumberGuardian
                        ? errors?.phoneNumberGuardian?.type === 'required'
                          ? 'Phone number is required.'
                          : errors?.phoneNumberGuardian?.type === 'pattern'
                          ? 'Please use 9 digits & numeric values only'
                          : 'Phone number is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="emailguardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z0-9@.!#$%&'*+-/=?^_`{|}~]*$/i,
                  maxLength: 122,
                  validate: handleEmailValidation,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="emailguardian"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionTwoForm?.emailguardian}
                    label={
                      <span>
                        Email address <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.emailguardian)}
                    helperText={
                      errors?.emailguardian
                        ? errors?.emailguardian?.type === 'required'
                          ? 'Email address is required.'
                          : errors?.State?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : errors?.State?.type === 'validate'
                          ? 'Enter a valid email address in format: example@example.com'
                          : 'Email address is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
        </form>
        <Grid item xs={12}>
          <Item elevation={0}>
            {NeedsLegalDocumentation && !isfileUploadSt ? (
              <Box className="uploadedFiles">
                <InlineAlert
                  fullWidth
                  severity="info"
                  text={
                    <div>
                      <div style={{ textAlign: 'justify', lineHeight: 1.6 }}>
                        *If you are the adult patient's {relationshiptoPatient} please attach to this form copies of any
                        legal documentation demonstrating that you are the {relationshiptoPatient}, if such
                        documentation is not already on file in the patient's medical record.
                      </div>
                      <div style={{ marginTop: '24px', textAlign: 'left', lineHeight: 1.6 }}>
                        You must upload requested legal documentation to submit form.
                      </div>
                    </div>
                  }
                />
              </Box>
            ) : null}
            {NeedsLegalDocumentation ? (
              <UploadFileControl
                patientName={patientName}
                uploadStateChange={uploadCompleted}
                formid={'AdultProxyForm'}
              />
            ) : null}
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item elevation={0}>
            <form onSubmit={handleSubmit(handleRegistration)}>
              <Button text="Continue" color="primary" type="submit" disabled={!isfileUploadSt} />
            </form>
          </Item>
        </Grid>
      </Grid>
    </Box>
  )
}
export default adultPageTwo
